export const getGeneralPermissionValidator = (state = {}) => {
  const permissions = state?.permissions?.permissoes;

  const isCompanyAdmin = permissions?.administradorEmpresa === 1;
  const isBranchAdmin = permissions?.administradorFilial === 1;

  return (permission) =>
    isCompanyAdmin ||
    isBranchAdmin ||
    !!(permissions && permissions.permissoesGerais.some((p) => p === permission));
}
